export default [
  {
    path: "/brackets",
    component: () =>
      import(/* webpackChunkName: "brackets" */ "@/views/brackets/Brackets"),
    children: [
      {
        path: "",
        name: "brackets",
        meta: {
          layout: "LayoutSidebar"
        },
        component: () =>
          import(
            /* webpackChunkName: "brackets" */ "@/views/brackets/BracketCategories"
          )
      },
      {
        path: "iframe",
        name: "brackets-iframe",
        props: {
          iframe: true
        },
        component: () =>
          import(
            /* webpackChunkName: "brackets" */ "@/views/brackets/BracketCategories"
          )
      },
      {
        path: "final",
        name: "brackets-final",
        component: () =>
          import(
            /* webpackChunkName: "brackets-final" */ "@/views/brackets/BracketFinal"
          )
      },
      {
        path: ":slug",
        name: "brackets-view",
        component: () =>
          import(
            /* webpackChunkName: "brackets-view" */ "@/views/brackets/BracketsView"
          )
      }
    ]
  }
];
